import DeviceBySiteModal from './device-by-site-modal.connect'

export default DeviceBySiteModal
